import { useState } from "react"
import { useSelector } from "react-redux"
import { Link, NavLink } from "react-router-dom"

import {
    Badge,
    Collapse,
    Container,
    Nav,
    NavItem,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap"


const Layout = ({ children }) => {

    const currentUser = useSelector(({ usuario }) => usuario.currentUser)

    const [isOpen, setIsOpen] = useState(false)

    const toggleNavbar = () => setIsOpen(!isOpen)

    return(
        <>
            <header>
                <Navbar
                    fixed="top"
                    expand="md"
                    color="secondary"
                    dark
                >
                    <NavbarBrand tag={Link} to="/">
                        TerraBella
                    </NavbarBrand>
                    <NavbarToggler onClick={toggleNavbar} className="me-2" />
                    <Collapse isOpen={isOpen} navbar>
                        {(currentUser == null) ?
                            <Nav>
                                <NavItem className="m-2">
                                    <NavLink to="/Login" tag={Link} className="text-info text-decoration-none">Login</NavLink>
                                </NavItem>
                            </Nav>
                            :
                            <Nav navbar>
                                <NavItem className="m-2">
                                    <NavLink to="/Proyectos" tag={Link} className="text-info text-decoration-none">Proyectos</NavLink>
                                </NavItem>
                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle className="text-info" nav caret>
                                        Reportes
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem tag={Link} to="/Reportes/Pagos/Vencidos">
                                            Pagos Vencidos
                                        </DropdownItem>
                                        <DropdownItem divider />
                                        <DropdownItem tag={Link} to="/Reportes/Cotizaciones">
                                            Cotizaciones
                                        </DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                                <NavItem className="m-2">
                                    <NavLink to="/Canjes" tag={Link} className="text-info text-decoration-none">Canjes</NavLink>
                                </NavItem>
                                <NavItem className="m-2">
                                    <NavLink to="/Usuarios" tag={Link} className="text-info text-decoration-none">Usuarios</NavLink>
                                </NavItem>
                                <NavItem className="m-2">
                                    <NavLink to="/Usuarios" tag={Link} className="text-danger text-decoration-none">Cerrar Sesión</NavLink>
                                </NavItem>
                            </Nav>
                        }
                    </Collapse>
                </Navbar>
            </header>

            <main className="flex-shrink-0">
                {children}
            </main>

            <footer className="footer mt-auto py-3 bg-body-tertiary">
                <Container>
                    <span className="text-body-secondary">
                        &copy; 2023 - TerraBella Grupo Inmobiliario <Badge>v1.0.0</Badge>
                    </span>
                </Container>
            </footer>
        </>
    )
}

export default Layout